import { LoadingIconButton } from '@chipinside/frontend'
import { ElementGroup } from '@chipinside/pagebuilder/dist/types'
import { Translate } from '@chipinside/translate'
import { Button, Divider } from '@mui/material'
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import { isEmpty } from 'lodash'
import React from 'react'
import { Link } from 'react-router-dom'

import { Icon } from '#/components/Icon'
import { useFarmSlug } from '#/store/ducks/farm'
import Colors from '#/styles/Colors'

const StyledBox = styled(Box)({
  display: 'flex',
  gap: 10,
  justifyContent: 'flex-end',
  padding: '12px',
})

const ACTION_TYPES = {
  'access-batch': ({ farm, id }) => (
    <React.Fragment key={id}>
      <Divider sx={{ opacity: 0.7 }} />
      <StyledBox id={`${id}-actions`}>
        <Link to={`/farm/${farm}/modules/herd/batch`}>
          <Button variant="outlined">
            {Translate({
              messageKey: 'access_item',
              params: {
                item: Translate({ lower: true, messageKey: 'batch_plural' }),
              },
            })}
          </Button>
        </Link>
      </StyledBox>
    </React.Fragment>
  ),
  'access-infirmary': ({ farm, id }) => (
    <React.Fragment key={id}>
      <Divider sx={{ opacity: 0.7 }} />
      <StyledBox id={`${id}-actions`}>
        <Link to={`/farm/${farm}/modules/health/infirmary`}>
          <Button variant="outlined">
            {Translate({
              messageKey: 'access_item',
              params: {
                item: Translate({ lower: true, messageKey: 'infirmary' }),
              },
            })}
          </Button>
        </Link>
      </StyledBox>
    </React.Fragment>
  ),
  'delete': ({ id, label, level }) => (
    <LoadingIconButton
      key={id}
      size="small"
      title={label}
      icon={<Icon name="x" size={18} />}
      style={{ color: Colors.feedback[level]?.color }}
    />
  ),
  'edit': ({ id, label, level }) => (
    <LoadingIconButton
      key={id}
      size="small"
      title={label}
      icon={<Icon name="check" size={18} />}
      style={{ color: Colors.feedback[level]?.color }}
    />
  ),
}

export const PageBuilderActions = ({ actions, id }: ElementGroup) => {
  const farmSlug = useFarmSlug()

  return !isEmpty(actions) ? (
    <div key={id}>
      {actions?.map(action => ACTION_TYPES[action.id]?.({ ...action, farm: farmSlug }))}
    </div>
  ) : null
}
